import App from "../App";
import HomePage from "@containers/HomePage";
import PublicSchemeDetails from "@containers/SchemeDetails";
import PublicPageDetails from "@containers/Page/Loadable";
import ProductListPublic from "@containers/ProductsList/Loadable";
import ConsumerPage from "@containers/ConsumerPage";

export const PublicRoutes = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/login",
    element: <App />,
  },
  {
    path: "/scheme/:id",
    element: <PublicSchemeDetails />,
  },
  {
    path: "/page/:page_key",
    element: <PublicPageDetails />,
  },
  {
    path: "/products",
    element: <ProductListPublic />,
  },
  {
    path: "/consumer",
    element: <ConsumerPage />,
  },
];
